<template>
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>

    <UNotifications class="dark" />
</template>

<script setup lang="ts">
useHead({
    titleTemplate: (title) => `${title ? (title + ' – ') : ''} SAMU Liban`,
})

// Enhanced error handling for ToDesktop
if (process.client) {
  window.addEventListener('error', (event) => {
    if (event.error?.message?.includes('Failed to fetch') || 
        event.error?.message?.includes('Loading chunk')) {
      console.warn('Dynamic import failed, attempting reload:', event.error)
      setTimeout(() => window.location.reload(), 1000)
    }
  })

  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason?.message?.includes('Failed to fetch') || 
        event.reason?.message?.includes('Loading chunk')) {
      console.warn('Promise rejection - dynamic import failed:', event.reason)
      event.preventDefault()
      setTimeout(() => window.location.reload(), 1000)
    }
  })
}
</script>
